module.exports = __webpack_public_path__ + "img/_5.0729dad9.png";